module.exports = __webpack_public_path__ + "static/media/PersonIconColored.123085e1.svg";